export default __webpack_public_path__ + "static/media/gt_hero_cut.2fd20403.png";